import { Chip } from '@medifind/shared-basic-components';
import styles from './FilterChips.module.scss';

const FilterChips = ({ values = [], explanation, onChipUpdate }) => {
  return (
    !(!explanation && (!values || values.length === 0)) && (
      <div className={styles['criteria-chips']}>
        {!values || values.length === 0 ? (
          <div className={styles['explanation']}>{explanation && explanation}</div>
        ) : (
          values.map(({ display, value }, i) => (
            <Chip
              key={`${value}-${i}`}
              onClick={() => {
                const tempArr = [...values];
                tempArr.splice(i, 1);
                onChipUpdate && onChipUpdate(tempArr);
              }}
              label={display}
            />
          ))
        )}
      </div>
    )
  );
};

export { FilterChips as default, FilterChips };
